<script setup lang="ts">
import comarkResolveComponent from "../../utils/comark-components-manifest";
import binding, { Binding } from '@comark/nuxt/plugins/binding'

const props = defineProps<{
  page: Object,
  data: Object,
}>()
</script>

<template>
  <div v-if="!page?.content.includes('::PageHero', '::PageHeader')">
    <UPageHeader :title="page?.title" v-if="!page?.content.includes('::PageHero', '::PageHeader')"  />
    <UPageBody>
      <Markdown :value="page?.content" :components-manifest="comarkResolveComponent" :plugins="[binding()]" :components="{ Binding }" :data="data" />
    </UPageBody>
  </div>
  <div v-else>
    <Markdown :value="page?.content" :components-manifest="comarkResolveComponent" :plugins="[binding()]" :components="{ Binding }" :data="data" />
  </div>

</template>